import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Plus, ChevronDown, LogIn } from 'lucide-react';
import logo from '../assets/logo.svg';
import authService from '../services/authService';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    authService.getCurrentUser()
      .then(data => setUser(data.user || null))
      .catch(() => setUser(null));
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await authService.logout().catch(() => {});
    setUser(null);
    setDropdownOpen(false);
    navigate('/');
  };

  const handleAddTutor = (e) => {
    e.preventDefault();
    navigate(user ? '/add-tutor' : '/register');
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="Logo" className="logo-img" />
        </Link>

        <nav className="nav">
          <Link to="/" className="nav-link">Գտնել մասնագետ</Link>
          <div className="nav-user-actions">
            <a href="/register" className="nav-link add-tutor-btn" onClick={handleAddTutor}>
              <Plus size={16} />
              <span className="add-tutor-text">Դառնալ մասնագետ</span>
            </a>
            {user ? (
              <div className="nav-dropdown" ref={dropdownRef}>
                <button
                  type="button"
                  className="nav-dropdown-trigger"
                  onClick={() => setDropdownOpen(o => !o)}
                >
                  Իմ էջը <ChevronDown size={14} />
                </button>
                {dropdownOpen && (
                  <div className="nav-dropdown-menu">
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => setDropdownOpen(false)}>
                      Իմ էջը
                    </Link>
                    <button type="button" className="nav-dropdown-item nav-dropdown-logout" onClick={handleLogout}>
                      Դուրս գալ
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="nav-link nav-login-btn">
                <LogIn size={16} aria-hidden />
                <span className="nav-login-text">Մուտք</span>
              </Link>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
